package com.eladfinish.bible.contest.logging

import io.github.aakira.napier.Antilog
import io.github.aakira.napier.LogLevel

// touchlab crashKios has no wasmJs target; Firebase has no web crash-reporting product anyway.
expect fun logCrashlyticsMessage(message: String)

class NapierCrashlyticsLog : Antilog() {
    override fun performLog(
        priority: LogLevel,
        tag: String?,
        throwable: Throwable?,
        message: String?,
    ) {
        logCrashlyticsMessage(
            buildLog(priority, tag, throwable, message)
        )
    }

    private fun buildLog(
        priority: LogLevel,
        tag: String?,
        throwable: Throwable?,
        message: String?,
    ): String {
        var log = "[${priority.toLogString()}]"

        if (tag != null) {
            log += " [$tag]"
        }

        if (message != null) {
            log += " $message"
        }

        throwable?.run {
            log += "\n${this.stackTraceToString()}"
        }

        return log
    }
}

private fun LogLevel.toLogString(): String = when (this) {
    LogLevel.VERBOSE -> "V"
    LogLevel.DEBUG -> "D"
    LogLevel.INFO -> "I"
    LogLevel.WARNING -> "W"
    LogLevel.ERROR -> "E"
    LogLevel.ASSERT -> "A"
}
